<template>
    <Datatable
        name="History"
        hideActions
        :hover="false"
        :loading="loading"
        :pagination.sync="pagination"
        @search="fetchData"
        searchClass="d-none"
    >
        <template v-slot:thead>
            <tr>
                <th>Event</th>
                <th>Old values</th>
                <th>New values</th>
            </tr>
        </template>
        <tr v-for="(change, index) in changes" :key="index">
            <td>
                <ul class="list-unstyled">
                    <!-- Author -->
                    <li class="mb-1">
                        <a v-if="change.by && change.by.id" href="#" @click.prevent="openUser(change.by.id)"
                            ><Icon class="me-1" icon="user" />{{ change.by.full_name || change.by.email }}</a
                        >
                    </li>
                    <!-- Date -->
                    <li class="mb-1">{{ change.created_at | formatDate }}</li>
                    <!-- Event -->
                    <li>
                        <Badge color="primary" small>{{ change.event || 'N/D' }}</Badge>
                    </li>
                </ul>
            </td>
            <!-- Old values -->
            <td><RawOutput v-if="change.old_values" :item="change.old_values" /></td>
            <!-- New values -->
            <td><RawOutput v-if="change.new_values" :item="change.new_values" /></td>
        </tr>
    </Datatable>
</template>

<script>
    import { Alerts, Badge, Datatable } from '@tech_hexeko/design-system'
    import { formatError } from '@/plugins/errors.js'
    import RawOutput from '@/components/RawOutput'

    export default {
        name: 'AuditTrail',
        components: { Badge, Datatable, RawOutput },
        props: {
            id: {
                type: [Number, String],
                required: true,
            },
            model: {
                type: String,
                required: true,
                validator: (value) => {
                    return [
                        'allowance',
                        'card',
                        'expense_request',
                        'partner',
                        'payment_intent',
                        'payment_transaction',
                        'user',
                        'wallet',
                    ].includes(value)
                },
            },
        },
        data() {
            return {
                changes: null,
                loading: true,
                pagination: {
                    current_page: 1,
                },
            }
        },
        methods: {
            async fetchData() {
                this.loading = true
                if (!this.id || !this.model) return
                try {
                    const payload = {
                        page: this.pagination.current_page,
                    }
                    const response = await this.$api.audits.get(this.model, this.id, payload)
                    this.changes = response.data
                    this.pagination = response.meta.pagination
                } catch (error) {
                    const errorTxt = formatError(error)
                    Alerts.notificationError(errorTxt)
                } finally {
                    this.loading = false
                }
            },
            openUser(id) {
                this.openPanel('userPanel', id)
            },
        },
        watch: {
            id: {
                immediate: true,
                handler(newId) {
                    if (!newId) return
                    this.fetchData()
                },
            },
        },
    }
</script>
